module.exports = __webpack_public_path__ + "img/weight1.71cc8c8d.svg";